
import React from 'react';
import { motion } from 'framer-motion';
import { Building2, Users, Briefcase, GraduationCap } from 'lucide-react';

const WhoWeHelp = () => {
  const audiences = [
    {
      icon: Building2,
      title: 'Enterprises',
      description: 'Large organisations seeking comprehensive security training and assessment programs'
    },
    {
      icon: Users,
      title: 'IT Teams',
      description: 'Technical professionals looking to upskill in cybersecurity practices'
    },
    {
      icon: Briefcase,
      title: 'Businesses',
      description: 'SMBs protecting their digital assets and meeting compliance requirements'
    },
    {
      icon: GraduationCap,
      title: 'Individuals',
      description: 'Aspiring cybersecurity professionals building their careers'
    }
  ];

  return (
    <section className="py-20 px-4 sm:px-6 lg:px-8 bg-white">
      <div className="max-w-7xl mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          className="text-center mb-16"
        >
          <h2 className="text-4xl md:text-5xl font-bold mb-4">
            <span className="bg-gradient-to-r from-[#422680] via-[#660F56] to-[#F54952] bg-clip-text text-transparent">
              Who We Help
            </span>
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Empowering organisations and individuals with cutting-edge cybersecurity expertise
          </p>
        </motion.div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
          {audiences.map((audience, index) => {
            const Icon = audience.icon;
            return (
              <motion.div
                key={index}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ delay: index * 0.1 }}
                className="bg-gradient-to-br from-gray-50 to-white p-8 rounded-2xl border border-gray-100 hover:border-[#422680] hover:shadow-xl transition-all group"
              >
                <div className="w-16 h-16 bg-gradient-to-br from-[#422680] to-[#F54952] rounded-xl flex items-center justify-center mb-6 group-hover:scale-110 transition-transform">
                  <Icon className="text-white" size={32} />
                </div>
                <h3 className="text-xl font-bold text-gray-900 mb-3">{audience.title}</h3>
                <p className="text-gray-600">{audience.description}</p>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default WhoWeHelp;
